// Mirrors Domain\Quotation\Models\BankAccount.

/** SurePay's verdict on the account number itself. Only `invalid` ever blocked a submission. */
export type SurepayOutcome = "valid" | "invalid" | "unverified";

export type SurepayAccountStatus = "ACTIVE" | "NOT_FOUND" | "UNKNOWN";

export type SurepayNameMatchResult =
	| "MATCH"
	| "CLOSE_MATCH"
	| "NO_MATCH"
	| "NOT_CHECKED";

export interface IBankAccount {
	id: string;
	customer_id: number;
	iban: string;
	account_holder: string;

	// All optional: rows written before the SurePay check shipped have these null,
	// and surepay_checked_at is what distinguishes "never asked" from "asked and
	// could not find out".
	surepay_outcome?: SurepayOutcome | null;
	surepay_account_status?: SurepayAccountStatus | null;
	surepay_name_match_result?: SurepayNameMatchResult | null;
	surepay_name_suggestion?: string | null;
	surepay_payment_pre_validation?: string | null;
	surepay_account_type?: string | null;
	surepay_account_age?: string | null;
	surepay_checked_at?: string | null;
}

export const defaultBankAccount: IBankAccount = {
	id: "",
	customer_id: 0,
	iban: "",
	account_holder: "",

	surepay_outcome: null,
	surepay_account_status: null,
	surepay_name_match_result: null,
	surepay_name_suggestion: null,
	surepay_payment_pre_validation: null,
	surepay_account_type: null,
	surepay_account_age: null,
	surepay_checked_at: null,
};

export interface ICustomer {
	id: number;

	firstname: string;
	lastname: string | null;
	email: string;
	phone_number: string;
	address: string;
	house_number: string;
	postal_code:string;
	city: string;

	company_name: string;
	company_email: string;
	chamber_of_commerce_number: string;

	payment_type: string;

	remarks: string;
	signature: string;

	bank_account?: IBankAccount
}

export const defaultCustomer: ICustomer = {
	id: 0,

	firstname: "",
	lastname: "",
	email: "",
	phone_number: "",
	address: "",
	house_number: "",
	postal_code: "",
	city: "",
	
	company_name: "",
	company_email: "",
	chamber_of_commerce_number: "",

	payment_type: "",

	remarks: "",
	signature: "",
};
